export default __webpack_public_path__ + "static/media/sapphire2.01ce293a.jpg";